import { render, staticRenderFns } from "./FaqsEditModal.vue?vue&type=template&id=1a82e358&scoped=true"
import script from "./FaqsEditModal.vue?vue&type=script&lang=js"
export * from "./FaqsEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a82e358",
  null
  
)

export default component.exports